export const cardDetailsFieldForDisplay = {
  'Client::Card::Personal': 'Nome do dono',
  'Client::Card::Fleet': 'Placa do veículo',
};
